/***************************************************************************************************/
/*                                 Main Menu                                                      */
/***************************************************************************************************/
// tslint:disable:max-line-length
// tslint:disable:no-empty-interface
import * as lodash from "lodash";
import {
    AbstractTCITenantComponentOptions,
    ITCIOptionType,
    ITCITenantComponentOptions,
    TCITenantSelectorType
} from "./tci-tenant";
import {TCITenantAppType} from "./tci-application";

// export interface ITCIHeaderProvider extends ITCIAppCustomizationProvider {
//     /**
//      * Can be shown or not
//      * @param item
//      */
//     isVisible(item: TCIMainMenu): Observable<boolean>;
//
//     /**
//      * If the item is visible, is it enabled?
//      * @param item
//      */
//     isEnabled(item: TCIMainMenu): Observable<boolean>;
//
//     /**
//      * Has logo
//      */
//     hasLogoUrl(): Observable<boolean>;
//
//     /**
//      * Get Logon Url
//      */
//     getLogoUrl(): Observable<string>;
//
//     /**
//      * Can show Help Panel
//      */
//     canShowHelpPanel(): Observable<boolean>;
//
//     /**
//      * Can show global Nav Bar
//      */
//     canShowGlobalNavBar(): Observable<boolean>;
// }

export const TCI_MAIN_MENU_TYPE: ITCIOptionType<string> = {
    GLOBAL_NAV_BAR: "global",
    MAIN_MENU: "main",
    HAMBURGER_MENU: "hamburger"
};
export type TCI_MAIN_MENU_TYPE = keyof typeof TCI_MAIN_MENU_TYPE | string;

function compareFn(
    a: ITCITenantComponentOptions<TCI_MAIN_MENU_TYPE>,
    b: ITCITenantComponentOptions<TCI_MAIN_MENU_TYPE>
) {
    if (a.getPosition() < b.getPosition()) {
        return -1;
    } else if (a.getPosition() > b.getPosition()) {
        return 1;
    } else {
        return 0;
    }
}

export interface ITCIMainMenuComponentOptions<T> extends ITCITenantComponentOptions<T> {
    isAlwaysAvailable(): boolean;
}

export class TCIMainMenuSubroutes {
    public static TCI_APPLICATION_APP_LIST = new TCIMainMenuSubroutes("list");
    public static TCI_APPLICATION_APP_DETAILS = new TCIMainMenuSubroutes("details");
    private constructor(private subrouteId: string) {
    }
    getSubRouteId(): string {
        return this.subrouteId;
    }
}

export class TCIMainMenu extends AbstractTCITenantComponentOptions<TCI_MAIN_MENU_TYPE>
    implements ITCIMainMenuComponentOptions<TCI_MAIN_MENU_TYPE> {
    public static MAIN_MENU_APPLICATIONS = new TCIMainMenu("Apps", 1, TCI_MAIN_MENU_TYPE.MAIN_MENU, "applications", [
        TCITenantAppType.scribe,
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node
    ], [TCIMainMenuSubroutes.TCI_APPLICATION_APP_LIST, TCIMainMenuSubroutes.TCI_APPLICATION_APP_DETAILS], true);
    public static MAIN_MENU_MARKETPLACE_V1 = new TCIMainMenu("Marketplace v1", 1, TCI_MAIN_MENU_TYPE.MAIN_MENU, "marketplacev1", [
        TCITenantAppType.scribe,
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node
    ], [], true);
    public static MAIN_MENU_MARKETPLACE_V2 = new TCIMainMenu("Marketplace", 1, TCI_MAIN_MENU_TYPE.MAIN_MENU, "marketplace", [
        TCITenantAppType.scribe,
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node
    ], [], true);
    public static MAIN_MENU_CONNECTIONS = new TCIMainMenu("Connections", 1, TCI_MAIN_MENU_TYPE.MAIN_MENU, "connections", [
        TCITenantAppType.scribe,
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node
    ], [], true);
    public static MAIN_MENU_ENV_TOOLS = new TCIMainMenu("Environment & Tools", 1, TCI_MAIN_MENU_TYPE.MAIN_MENU, "envtools", [
        TCITenantAppType.scribe,
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node
    ], [], true);

    // public static MAIN_MENU_SECURITY = new TCIMainMenu(
    //     "Security",
    //     1,
    //     TCI_MAIN_MENU_TYPE.MAIN_MENU,
    //     "security",
    //     [
    //         TCITenantAppType.scribe,
    //         TCITenantAppType.flogo,
    //         TCITenantAppType.bw,
    //         TCITenantAppType.mock,
    //         TCITenantAppType.modeler,
    //         TCITenantAppType.node,
    //     ]);

    // public static MAIN_MENU_SCRIBEUI = new TCIMainMenu(
    //     "Scribe Apps",
    //     1,
    //     TCI_MAIN_MENU_TYPE.MAIN_MENU,
    //     "scribeui",
    //     [
    //         TCITenantAppType.scribe,
    //         TCITenantAppType.flogo,
    //         TCITenantAppType.bw,
    //         TCITenantAppType.mock,
    //         TCITenantAppType.modeler,
    //         TCITenantAppType.node,
    //     ]);

    // public static MAIN_MENU_API_SPECS = new TCIMainMenu(
    //     "API Specs",
    //     1,
    //     TCI_MAIN_MENU_TYPE.MAIN_MENU,
    //     "apispecs",
    //     [
    //         TCITenantAppType.scribe,
    //         TCITenantAppType.flogo,
    //         TCITenantAppType.bw,
    //         TCITenantAppType.mock,
    //         TCITenantAppType.modeler,
    //         TCITenantAppType.node,
    //     ]);

    public static MAIN_MENU_EXTENSIONS = new TCIMainMenu("Extensions", 1, TCI_MAIN_MENU_TYPE.MAIN_MENU, "wistudio/extensions", [
        TCITenantAppType.flogo
    ], []);

    public static MAIN_MENU_SHOW_HELP = new TCIMainMenu("Help", 1, TCI_MAIN_MENU_TYPE.MAIN_MENU, "showHelpPanel()", [
        TCITenantAppType.scribe,
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node
    ], []);

    private static allItems = [
        TCIMainMenu.MAIN_MENU_APPLICATIONS,
        // TCIMainMenu.MAIN_MENU_MARKETPLACE_V1,
        TCIMainMenu.MAIN_MENU_MARKETPLACE_V2,
        TCIMainMenu.MAIN_MENU_CONNECTIONS,
        TCIMainMenu.MAIN_MENU_ENV_TOOLS,
        TCIMainMenu.MAIN_MENU_EXTENSIONS
    ];

    private alwaysAvailable = false;

    /**
     * Gets All items
     * @param filter to provided based on the ITCICustomizationProvider
     * @return @ITCITenantEnvTools[]
     */
    public static getAllItems(
        filter?: (data: ITCIMainMenuComponentOptions<TCI_MAIN_MENU_TYPE>) => boolean): TCIMainMenu[] {
        if (filter) {
            return TCIMainMenu
                .allItems
                .filter(filter)
                .sort(compareFn);
        }
        return TCIMainMenu.allItems
            .filter((data) => data.getLabel() !== "Extensions")
            .sort(compareFn);
    }

    /**
     * constructor
     * @param label
     * @param position
     * @param toolType
     * @param routeId
     * @param tenantAppTypes
     * @param alwaysAvailable
     */
    constructor(
        label: string,
        position: number,
        toolType: TCI_MAIN_MENU_TYPE,
        routeId: string,
        tenantAppTypes: TCITenantAppType[],
        subroutes: TCIMainMenuSubroutes[]
        , alwaysAvailable: boolean = false) {
        super(label, TCITenantSelectorType.createPseudoSelector("tci-main-menu"), position, toolType, routeId, tenantAppTypes, null);
        this.alwaysAvailable = alwaysAvailable;
    }

    public isAlwaysAvailable(): boolean {
        return this.alwaysAvailable;
    }

    equals(that): boolean {
        // Shortcut for trivial case
        if (this === that) {
            return true;
        }

        // If the that object is not a set, it is not equal to this one.
        // We use instanceof to allow any subclass of Set.
        // We could relax this test if we wanted true duck-typing.
        // Or we could strengthen it to check this.constructor == that.constructor
        // Note that instanceof properly rejects null and undefined values
        if (!(that instanceof TCIMainMenu)) {
            return false;
        }

        return lodash.isEqual(this, that);
    }
}
